import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterSelect } from './filters/lightbox_filter_select';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';
import Translation from "../../../translation/translation";

function LightboxTyreRatings(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.TYRE_RATINGS_VIEW];
    const utqgTreadwearGroupTranslationKey = FilterLabelTranslationKeys[Filters.UTQG_TREADWEAR_GROUP];
    const utqgTractionTranslationKey = FilterLabelTranslationKeys[Filters.UTQG_TRACTION];
    const utqgTemperatureTranslationKey = FilterLabelTranslationKeys[Filters.UTQG_TEMPERATURE];

    return (
        <LightboxView
            viewName={FilterSections.TYRE_RATINGS_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <div className="lightbox-filter-section__headline">
                    <Translation translationKey="catalog-filter-group-label" />
                </div>
                <LightboxFilterSelect
                    name={Filters.LABEL_NOISE}
                    value={props.labelNoiseValue}
                    options={props.labelNoiseOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_NOISE]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_NOISE]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.LABEL_WET_GRIP}
                    value={props.labelWetGripValue}
                    options={props.labelWetGripOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_WET_GRIP]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_WET_GRIP]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.LABEL_FUEL_EFFICIENCY}
                    value={props.labelFuelEfficiencyValue}
                    options={props.labelFuelEfficiencyOptions}
                    labelTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_FUEL_EFFICIENCY]}
                    provideAllTranslationKey={FilterLabelTranslationKeys[Filters.LABEL_FUEL_EFFICIENCY]}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />

                <div className="lightbox-filter-section__headline">
                    <Translation translationKey="catalog-filter-group-utqg" />
                </div>
                <LightboxFilterSelect
                    name={Filters.UTQG_TREADWEAR_GROUP}
                    value={props.utqgTreadwearGroupValue}
                    options={props.utqgTreadwearGroupOptions}
                    labelTranslationKey={utqgTreadwearGroupTranslationKey}
                    provideAllTranslationKey={utqgTreadwearGroupTranslationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.UTQG_TRACTION}
                    value={props.utqgTractionValue}
                    options={props.utqgTractionOptions}
                    labelTranslationKey={utqgTractionTranslationKey}
                    provideAllTranslationKey={utqgTractionTranslationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
                <LightboxFilterSelect
                    name={Filters.UTQG_TEMPERATURE}
                    value={props.utqgTemperatureValue}
                    options={props.utqgTemperatureOptions}
                    labelTranslationKey={utqgTemperatureTranslationKey}
                    provideAllTranslationKey={utqgTemperatureTranslationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.value}
                    unavailableOptions={[]}
                />
            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxTyreRatings.propTypes = {
    utqgTreadwearGroupValue: PropTypes.string.isRequired,
    utqgTreadwearGroupOptions: PropTypes.array.isRequired,

    utqgTractionValue: PropTypes.string.isRequired,
    utqgTractionOptions: PropTypes.array.isRequired,

    utqgTemperatureValue: PropTypes.string.isRequired,
    utqgTemperatureOptions: PropTypes.array.isRequired,

    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxTyreRatings };
